/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import PropTypes from 'prop-types'
import ButtonToggleSmall from 'react-wot-bootstrap/lib/components/ButtonToggleSmall/ButtonToggleSmall'

class FilterSelectButton extends React.Component {
    static propTypes = {
        value: PropTypes.any,
        isChecked: PropTypes.bool,
        caption: PropTypes.element,
        onChange: PropTypes.func.isRequired,
        tooltipId: PropTypes.string,
        cssClassName: PropTypes.string,
    }

    handleClick = () => {
        this.props.onChange(this.props.value)
    }

    render() {
        const tooltipProps = this.props.tooltipId ? {
            'data-tip': this.props.value,
            'data-for': this.props.tooltipId,
        } : {}

        return (
            <div {...tooltipProps} className={this.props.cssClassName}>
                <ButtonToggleSmall
                    caption={this.props.caption}
                    isChecked={this.props.isChecked}
                    tabIndex={0}
                    onClick={this.handleClick}
                />
            </div>
        )
    }
}

export default FilterSelectButton



// WEBPACK FOOTER //
// ./containers/WGCWXShop/components/FilterSelectButton/FilterSelectButton.jsx